// extracted by mini-css-extract-plugin
export default {"keyboard":"Keyboard_keyboard__EiOGQ","duplicateString":"Keyboard_duplicateString__9zKzk","keyboardLine":"Keyboard_keyboardLine__c+7na"};